const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    INTERNAL_API_URL: 'https://tdrpxdy2q7.execute-api.ap-southeast-1.amazonaws.com/prod',
    TEAM_API_URL: 'https://iku1mq09yh.execute-api.ap-southeast-1.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.staging.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://auduqo2dzb.execute-api.ap-southeast-1.amazonaws.com/staging'
  },
};

export default config;
